// src/components/Chat.jsx
import React, { useEffect, useRef, useState } from "react";
import { sendMessage } from "../services/N8nService";
import { consultarOrdensCentro } from "../services/CentroService";
import { reprocessarOrdemVenda } from "../services/ReprocessService";
import { enviarImagem } from "../services/ImageService";
import "../styles/Chat.css";

/* ----------------------- Options (menu) ----------------------- */
const initialOptions = [
  { label: "📦 Consultar Entregas", action: "consultarCPF" },
  { label: "⏳ Consultar de ordens no Centro", action: "centro" },
  { label: "🖼️ Enviar Imagem para Resgate de Ingresso", action: "imagem" },
];

/* -------------------- Helpers de máscara -------------------- */
const onlyDigits = (str, max = undefined) => {
  const d = (str || "").replace(/\D/g, "");
  return typeof max === "number" ? d.slice(0, max) : d;
};

const maskCPF = (value) => {
  const d = onlyDigits(value, 11);
  let out = d;
  if (d.length > 3)  out = d.slice(0,3) + "." + d.slice(3);
  if (d.length > 6)  out = out.slice(0,7) + "." + out.slice(7);
  if (d.length > 9)  out = out.slice(0,11) + "-" + out.slice(11);
  return out;
};

const maskCentroData = (value) => {
  const d = onlyDigits(value, 11);
  const c = d.slice(0, 3);
  const dd = d.slice(3, 5);
  const mm = d.slice(5, 7);
  const yyyy = d.slice(7, 11);

  let out = c;
  if (d.length > 3) out += " " + dd;
  if (d.length > 5) out = `${c} ${dd}/${mm}`;
  if (d.length > 7) out = `${c} ${dd}/${mm}/${yyyy}`;
  return out;
};

const maskOV = (value) => onlyDigits(value, 8);

/* --------- Filtro de ordens ---------- */
function applyOrderFilter({ field, query }) {
  const q = (query || "").trim().toLowerCase();

  const cards = Array.from(
    document.querySelectorAll(".chat-window .html-content .order-card")
  );
  if (cards.length > 0) {
    cards.forEach((card) => {
      const cliente = (card.getAttribute("data-cliente") || "").toLowerCase();
      const ordem = (card.getAttribute("data-ordem") || "").toLowerCase();
      const pedido = (card.getAttribute("data-pedido") || "").toLowerCase();

      let match = true;
      if (q) {
        if (field === "cliente") match = cliente.includes(q);
        else if (field === "ordem") match = ordem.includes(q);
        else if (field === "pedido") match = pedido.includes(q);
        else match = cliente.includes(q) || ordem.includes(q) || pedido.includes(q);
      }
      card.style.display = match ? "" : "none";
    });
    return;
  }
}

function ResultFilter({ visible }) {
  const [field, setField] = useState("auto");
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (!visible) return;
    applyOrderFilter({ field, query });
  }, [visible, field, query]);

  if (!visible) return null;

  return (
    <div className="result-filter">
      <select value={field} onChange={(e) => setField(e.target.value)}>
        <option value="auto">Filtrar por: Automático</option>
        <option value="cliente">Nome do cliente</option>
        <option value="ordem">Ordem</option>
        <option value="pedido">Pedido</option>
      </select>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={
          field === "cliente" ? "Ex.: THALYS" :
          field === "ordem"   ? "Ex.: 59085361" :
          field === "pedido"  ? "Ex.: 009000..." :
                                "Digite o termo…"
        }
      />
      <button type="button" onClick={() => { setQuery(""); setField("auto"); }}>
        Limpar
      </button>
    </div>
  );
}

/* ------------------------- Chat Component ------------------------- */
export default function Chat() {
  const [chat, setChat] = useState([
    { from: "n8n", text: "Olá! Como posso te ajudar hoje? Escolha uma opção abaixo:" },
  ]);

  const [mode, setMode] = useState("menu");
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOrderFilter, setShowOrderFilter] = useState(false);

  // Slot 1: identidade
  const [imageFile1, setImageFile1] = useState(null);
  const [imagePreview1, setImagePreview1] = useState(null);

  // Slot 2: ingresso
  const [imageFile2, setImageFile2] = useState(null);
  const [imagePreview2, setImagePreview2] = useState(null);

  const [campanha, setCampanha] = useState("");
  const [matricula, setMatricula] = useState("");

  // Webcam
  const [showWebcam, setShowWebcam] = useState(false);
  const [webcamSlot, setWebcamSlot] = useState(1);

  const endRef = useRef(null);
  const fileInput1Ref = useRef(null);
  const fileInput2Ref = useRef(null);
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  const scrollToEnd = () =>
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });

  // ---------- webcam ----------
  const startWebcam = async (slot) => {
    setWebcamSlot(slot);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
      streamRef.current = stream;
      setShowWebcam(true);
    } catch {
      // fallback: abre input file com capture (mobile)
      if (slot === 1) fileInput1Ref.current?.click();
      else fileInput2Ref.current?.click();
    }
  };

  const stopWebcam = () => {
    streamRef.current?.getTracks().forEach((t) => t.stop());
    streamRef.current = null;
    setShowWebcam(false);
  };

  const capturePhoto = () => {
    const video = videoRef.current;
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    canvas.toBlob((blob) => {
      const label = webcamSlot === 1 ? "identidade" : "ingresso";
      const file = new File([blob], `foto-${label}.jpg`, { type: "image/jpeg" });
      const reader = new FileReader();
      if (webcamSlot === 1) {
        setImageFile1(file);
        reader.onloadend = () => setImagePreview1(reader.result);
      } else {
        setImageFile2(file);
        reader.onloadend = () => setImagePreview2(reader.result);
      }
      reader.readAsDataURL(file);
      stopWebcam();
    }, "image/jpeg", 0.9);
  };

  useEffect(() => {
    if (showWebcam && videoRef.current && streamRef.current) {
      videoRef.current.srcObject = streamRef.current;
      videoRef.current.play();
    }
  }, [showWebcam]);

  // ---------- image change handlers ----------
  const handleImageChange1 = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile1(file);
    const reader = new FileReader();
    reader.onloadend = () => setImagePreview1(reader.result);
    reader.readAsDataURL(file);
  };

  const handleImageChange2 = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile2(file);
    const reader = new FileReader();
    reader.onloadend = () => setImagePreview2(reader.result);
    reader.readAsDataURL(file);
  };

  const handleRemoveImage1 = () => {
    setImageFile1(null);
    setImagePreview1(null);
    if (fileInput1Ref.current) fileInput1Ref.current.value = "";
  };

  const handleRemoveImage2 = () => {
    setImageFile2(null);
    setImagePreview2(null);
    if (fileInput2Ref.current) fileInput2Ref.current.value = "";
  };

  // ---------- validações ----------
  const isValidDateBR = (br) => {
    const m = br.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!m) return false;
    const [_, dd, mm, yyyy] = m.map(Number);
    const dt = new Date(yyyy, mm - 1, dd);
    return dt.getFullYear() === yyyy && dt.getMonth() === mm - 1 && dt.getDate() === dd;
  };

  // ---------- menu helpers ----------
  const backToMenu = (msg = "Posso ajudar com algo mais? Escolha uma opção:", options = {}) => {
    const { keepFilter = false } = options;
    setChat((prev) => [...prev, { from: "n8n", text: msg }]);
    setMode("menu");
    setInputValue("");
    if (!keepFilter) setShowOrderFilter(false);
  };

  const handleAction = (action) => {
    switch (action) {
      case "consultarCPF":
        setShowOrderFilter(false);
        setMode("cpf");
        setInputValue("");
        setChat((prev) => [
          ...prev,
          { from: "n8n", text: "Por favor, informe o CPF para buscar as entregas:" },
        ]);
        break;

      case "centro":
        setShowOrderFilter(false);
        setMode("centro");
        setInputValue("");
        setChat((prev) => [
          ...prev,
          {
            from: "n8n",
            text:
              "Informe <b>centro e data</b> no formato: <b>### ##/##/####</b> (ex.: <b>601 20/05/2025</b>).",
          },
        ]);
        break;

      case "reprocessar":
        setShowOrderFilter(false);
        setMode("reprocessar");
        setInputValue("");
        setChat((prev) => [
          ...prev,
          { from: "n8n", text: "Informe o número da Ordem de Venda (8 dígitos):" },
        ]);
        break;

      case "imagem":
        setShowOrderFilter(false);
        setMode("imagem");
        setImageFile1(null);
        setImagePreview1(null);
        setImageFile2(null);
        setImagePreview2(null);
        setCampanha("");
        setMatricula("");
        setChat((prev) => [
          ...prev,
          {
            from: "n8n",
            text: "Envie a foto da <b>Identidade</b> e do <b>Ingresso</b>, informe a campanha e sua matrícula:",
          },
        ]);
        break;

      default:
        backToMenu();
    }
  };

  // ---------- máscara dinâmica por modo ----------
  const handleMaskedChange = (e) => {
    const raw = e.target.value;
    if (mode === "cpf") {
      setInputValue(maskCPF(raw));
    } else if (mode === "centro") {
      setInputValue(maskCentroData(raw));
    } else if (mode === "reprocessar") {
      setInputValue(maskOV(raw));
    } else {
      setInputValue(raw);
    }
  };

  const handlePasteDigitsOnly = (e) => {
    const text = (e.clipboardData || window.clipboardData).getData("text");
    if (!text) return;
    e.preventDefault();
    let masked = text;
    if (mode === "cpf") masked = maskCPF(text);
    else if (mode === "centro") masked = maskCentroData(text);
    else if (mode === "reprocessar") masked = maskOV(text);
    setInputValue(masked);
  };

  // ---------- envio ----------
  const handleSend = async () => {
    if (loading) return;

    // Modo imagem
    if (mode === "imagem") {
      if (!imageFile1 || !imageFile2) return;
      const camp = campanha.trim();
      const mat = matricula.trim();
      if (!camp || !mat) return;

      const f1 = imageFile1;
      const f2 = imageFile2;
      const p1 = imagePreview1;
      const p2 = imagePreview2;

      try {
        setLoading(true);
        setChat((prev) => [
          ...prev,
          {
            from: "user",
            text:
              `<b>Identidade:</b><br/><img src="${p1}" style="max-width:180px;border-radius:8px;" alt="identidade" />` +
              `<br/><b>Ingresso:</b><br/><img src="${p2}" style="max-width:180px;border-radius:8px;" alt="ingresso" />` +
              `<br/>Campanha: <b>${camp}</b> | Matrícula: <b>${mat}</b>`,
          },
          { from: "n8n", text: "Analisando as imagens..." },
        ]);

        setImageFile1(null); setImagePreview1(null);
        setImageFile2(null); setImagePreview2(null);
        setCampanha(""); setMatricula("");
        if (fileInput1Ref.current) fileInput1Ref.current.value = "";
        if (fileInput2Ref.current) fileInput2Ref.current.value = "";

        const reply = await enviarImagem(f1, f2, camp, mat);
        setChat((prev) => [...prev.slice(0, -1), { from: "n8n", text: reply }]);
        backToMenu("Tudo certo ✅. Quer fazer mais alguma coisa?");
      } catch {
        setChat((prev) => [
          ...prev.slice(0, -1),
          { from: "error", text: "Erro ao enviar as imagens. Tente novamente." },
        ]);
        backToMenu("Opa, tivemos um erro. Quer tentar outra opção?");
      } finally {
        setLoading(false);
      }
      return;
    }

    const value = inputValue.trim();
    if (!value) return;

    try {
      setLoading(true);
      setChat((prev) => [
        ...prev,
        { from: "user", text: value },
        { from: "n8n", text: "Processando sua solicitação..." },
      ]);
      setInputValue("");

      let reply = "";

      switch (mode) {
        case "cpf": {
          const digits = value.replace(/\D/g, "");
          if (digits.length !== 11) {
            setChat((prev) => [
              ...prev.slice(0, -1),
              { from: "error", text: "CPF inválido. Use o formato ###.###.###-##" },
            ]);
            return;
          }
          reply = await sendMessage(digits);
          break;
        }

        case "centro": {
          const m = value.match(/^(\d{3})\s(\d{2})\/(\d{2})\/(\d{4})$/);
          if (!m) {
            setChat((prev) => [
              ...prev.slice(0, -1),
              { from: "error", text: "Formato inválido. Use: 601 20/05/2025" },
            ]);
            return;
          }
          const centro = m[1];
          const data = `${m[2]}/${m[3]}/${m[4]}`;
          if (!isValidDateBR(data)) {
            setChat((prev) => [
              ...prev.slice(0, -1),
              { from: "error", text: `Data inválida: ${data}` },
            ]);
            return;
          }
          reply = await consultarOrdensCentro({ centro, data });
          break;
        }

        case "reprocessar": {
          const ovDigits = value.replace(/\D/g, "");
          if (!/^\d{8}$/.test(ovDigits)) {
            setChat((prev) => [
              ...prev.slice(0, -1),
              { from: "error", text: "Informe a OV com 8 dígitos." },
            ]);
            return;
          }
          reply = await reprocessarOrdemVenda({ ov: ovDigits });
          break;
        }

        default:
          return;
      }

      setChat((prev) => [...prev.slice(0, -1), { from: "n8n", text: reply }]);

      if (mode === "centro") {
        setShowOrderFilter(true);
        backToMenu("Tudo certo ✅. Quer fazer mais alguma coisa?", { keepFilter: true });
      } else {
        backToMenu("Tudo certo ✅. Quer fazer mais alguma coisa?");
      }
    } catch {
      setChat((prev) => [
        ...prev.slice(0, -1),
        { from: "error", text: "Erro ao processar a solicitação." },
      ]);
      backToMenu("Opa, tivemos um erro. Quer tentar outra opção?");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [chat, mode, showOrderFilter]);

  const placeholder = {
    menu: "",
    cpf: "CPF: ###.###.###-##",
    centro: "Centro e data: ### ##/##/####",
    reprocessar: "OV (8 dígitos)",
  }[mode];

  const canSendImage =
    !!imageFile1 && !!imageFile2 && campanha.trim() !== "" && matricula.trim() !== "";

  return (
    <div className="app-container">
      <img src="/images/robo.png" alt="Robô Bemol" className="robo-float" />
      <div className="chat-box">
        <h2 className="chat-title">💬 Chat de consultas Bemol</h2>

        {showOrderFilter && <ResultFilter visible={true} />}

        <div className="chat-window">
          {chat.map((msg, idx) => (
            <div key={idx} className={`chat-message ${msg.from}`}>
              <div className="html-content" dangerouslySetInnerHTML={{ __html: msg.text }} />
            </div>
          ))}

          {mode === "menu" && (
            <div className="chat-options">
              {initialOptions.map((opt) => (
                <button key={opt.action} onClick={() => handleAction(opt.action)}>
                  {opt.label}
                </button>
              ))}
            </div>
          )}
          <div ref={endRef} />
        </div>

        {mode !== "menu" && mode !== "imagem" && (
          <div className="chat-input">
            <input
              type="text"
              inputMode="numeric"
              autoComplete="off"
              value={inputValue}
              onChange={handleMaskedChange}
              onPaste={handlePasteDigitsOnly}
              placeholder={placeholder}
              onKeyDown={(e) => e.key === "Enter" && !loading && handleSend()}
              disabled={loading}
            />
            <button onClick={handleSend} disabled={loading}>
              {loading ? "Enviando..." : "Enviar"}
            </button>
          </div>
        )}

        {mode === "imagem" && (
          <div className="chat-input image-upload-area">
            {/* inputs ocultos */}
            <input type="file" accept="image/*" ref={fileInput1Ref} style={{ display: "none" }} onChange={handleImageChange1} />
            <input type="file" accept="image/*" ref={fileInput2Ref} style={{ display: "none" }} onChange={handleImageChange2} />

            {/* Slot 1: Identidade */}
            <div className="image-slot">
              <span className="image-slot-label">🪪 Identidade</span>
              <div className="image-picker-row">
                {imagePreview1 ? (
                  <div className="image-preview-container">
                    <img src={imagePreview1} alt="Identidade" className="image-preview" />
                    <button className="image-remove-btn" onClick={handleRemoveImage1} type="button" disabled={loading}>✕</button>
                  </div>
                ) : (
                  <>
                    <button className="image-select-btn" onClick={() => fileInput1Ref.current.click()} type="button" disabled={loading}>
                      📎 Upload
                    </button>
                    <button className="image-camera-btn" onClick={() => startWebcam(1)} type="button" disabled={loading}>
                      📷 Câmera
                    </button>
                  </>
                )}
              </div>
            </div>

            {/* Slot 2: Ingresso */}
            <div className="image-slot">
              <span className="image-slot-label">🎟️ Ingresso</span>
              <div className="image-picker-row">
                {imagePreview2 ? (
                  <div className="image-preview-container">
                    <img src={imagePreview2} alt="Ingresso" className="image-preview" />
                    <button className="image-remove-btn" onClick={handleRemoveImage2} type="button" disabled={loading}>✕</button>
                  </div>
                ) : (
                  <>
                    <button className="image-select-btn" onClick={() => fileInput2Ref.current.click()} type="button" disabled={loading}>
                      📎 Upload
                    </button>
                    <button className="image-camera-btn" onClick={() => startWebcam(2)} type="button" disabled={loading}>
                      📷 Câmera
                    </button>
                  </>
                )}
              </div>
            </div>

            {/* Campanha */}
            <input
              type="text"
              className="image-text-input"
              placeholder="Campanha"
              value={campanha}
              onChange={(e) => setCampanha(e.target.value)}
              disabled={loading}
            />

            {/* Matrícula */}
            <input
              type="text"
              className="image-text-input"
              placeholder="Matrícula do Colaborador"
              value={matricula}
              onChange={(e) => setMatricula(e.target.value)}
              disabled={loading}
            />

            {/* Enviar */}
            <button className="image-send-btn" onClick={handleSend} disabled={loading || !canSendImage}>
              {loading ? "Enviando..." : "Enviar"}
            </button>
          </div>
        )}
      </div>

      {/* Modal de webcam */}
      {showWebcam && (
        <div className="webcam-overlay">
          <div className="webcam-modal">
            <div className="webcam-label">
              {webcamSlot === 1 ? "🪪 Capturando Identidade" : "🎟️ Capturando Ingresso"}
            </div>
            <video ref={videoRef} className="webcam-video" autoPlay playsInline muted />
            <div className="webcam-actions">
              <button className="webcam-capture-btn" onClick={capturePhoto} type="button">
                📸 Tirar Foto
              </button>
              <button className="webcam-cancel-btn" onClick={stopWebcam} type="button">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
